// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadCarrierCard_card__1t61z"};